function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5223",
    d: "M34.125 42H7.875A7.875 7.875 0 0 1 0 34.125V7.875A7.875 7.875 0 0 1 7.875 0h26.25A7.875 7.875 0 0 1 42 7.875v26.25A7.875 7.875 0 0 1 34.125 42zm0 0",
    transform: "translate(.5 .5)",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "edit (2)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4362",
    d: "M17.339 43.183a.754.754 0 0 0-.754.754v7.539a.754.754 0 0 1-.754.754H2.262a.754.754 0 0 1-.754-.754V36.4a.754.754 0 0 1 .754-.754h9.046a.754.754 0 1 0 0-1.508H2.262A2.262 2.262 0 0 0 0 36.4v15.076a2.262 2.262 0 0 0 2.262 2.262h13.57a2.262 2.262 0 0 0 2.262-2.262v-7.539a.754.754 0 0 0-.755-.754z",
    transform: "translate(10.278 -22.352)",
    style: {
      fill: "#faa100"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4363",
    d: "M118.149.849a2.886 2.886 0 0 0-4.082 0l-9.93 9.929a.762.762 0 0 0-.182.295l-1.508 4.527a.754.754 0 0 0 .715.992.766.766 0 0 0 .238-.038l4.523-1.508a.754.754 0 0 0 .295-.182l9.93-9.93a2.886 2.886 0 0 0 .001-4.085z",
    transform: "translate(-87.607 10.273)",
    style: {
      fill: "#faa100"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.4bd8b7e32c601c7f037d19bbb7eba9a6.svg";
export { ForwardRef as ReactComponent };